import { render, staticRenderFns } from "./CargaArchivos.vue?vue&type=template&id=224a9cd3&"
import script from "./CargaArchivos.vue?vue&type=script&lang=js&"
export * from "./CargaArchivos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports